
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { IPagination } from '@/types';
import {
  getStockCheckList,
  setStockCheckNumber,
  saveStockCheck
} from '@/api/stock';
import DialogImgLarge from '@/components/ImgLarge/index.vue';
import StockCheckChildrenList from './components/StockCheckChildrenList.vue';
import { addNum } from '@/utils';

@Component({
  name: 'StockCheck',
  components: {
    DialogImgLarge,
    StockCheckChildrenList
  }
})
export default class extends Vue {
  private formSearch: any = {
    name: '',
    model_name: '',
    serial_number: '',
    specification: '',
    type: ''
  }
  private typeOptions = [{
    value: '1',
    label: '备件导入'
  }, {
    value: '2',
    label: '手动添加'
  }]
  private dataTable = []

  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  created() {
    this.getList();
  }

  // 收起所有已展开行（row-key 模式下数据刷新后展开状态会按 id 保留，需手动收起）
  private collapseAllRows() {
    const table: any = this.$refs.stockCheckTable;
    if (!table) {
      return;
    }
    const expandRows: any[] = (table.store.states.expandRows || []).slice();
    expandRows.forEach((row: any) => {
      table.toggleRowExpansion(row, false);
    });
  }

  private search() {
    this.pagination.currentPage = 1;
    this.collapseAllRows();
    this.getList();
  }

  private searchClean() {
    this.formSearch = {
      name: '',
      model_name: '',
      serial_number: '',
      specification: '',
      type: ''
    };
    this.pagination.currentPage = 1;
    this.collapseAllRows();
    this.getList();
  }

  // 页面属性更新
  private handlePageSizeChange(val: any) {
    this.pagination.pageSize = val;
    this.getList();
  }
  private handleCurrentChange(val: any) {
    this.pagination.currentPage = val;
    this.getList();
  }

  // 获取一级（大类）盘点列表
  private getList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.name = this.formSearch.name;
    params.model_name = this.formSearch.model_name;
    params.serial_number = this.formSearch.serial_number;
    params.specification = this.formSearch.specification;
    params.type = this.formSearch.type;
    params.pid = 0;
    params.page = this.pagination.currentPage;
    params.size = this.pagination.pageSize;
    getStockCheckList(params)
      .then((res) => {
        if (res.data) {
          this.pagination.total = parseInt(res.data.count);
          this.dataTable = res.data.list;
        } else {
          this.pagination.currentPage = 1;
          this.pagination.total = 0;
          this.dataTable = [];
        }
      })
      .catch((error) => {
        this.dataTable = [];
        let msg = error.msg;
      });
  }

  // 展开行：懒加载下级名称（盘点列表接口传 pid 获取）
  private handleExpandChange(row: any, expandedRows: any[]) {
    const expanded = expandedRows.some((item: any) => item.id === row.id);
    if (expanded) {
      this.fetchChildren(row);
    }
  }

  private fetchChildren(row: any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      pid: row.id,
      page: 1,
      size: 9999
    };
    getStockCheckList(params)
      .then((res: any) => {
        const data = res.data;
        const list = data && data.list ? data.list : [];
        this.$set(row, 'childrenx', list);
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  // 添加盘点库存
  private addStockCheck(val:any, val2:any) {

    if (val2.edit_num) {
      if(!/^[0-9]+(\.[0-9]{0,2})?$/.test(val2.edit_num)){
        this.showErrorMsg('请输入正确的数字格式(最多两位小数)');
        return;
      }
      let params: any = {};
      params.user_id = UserModule.getUserId;
      params.company_id = UserModule.getCompanyId;
      params.stock_id = val.id;
      params.model_id = val2.id;
      params.check_num = val2.edit_num;
      setStockCheckNumber(params)
        .then((res) => {
          this.showSuccessMsg('添加成功');
          // 局部更新，避免整表刷新导致多级展开状态丢失
          const numVal = parseFloat(val2.num) || 0;
          const checkNumVal = parseFloat(val2.edit_num) || 0;
          this.$set(val2, 'check_num', val2.edit_num);
          this.$set(val2, 'check_result', addNum(checkNumVal, -numVal));
          this.$set(val2, 'edit_num', '');
        })
        .catch((error) => {
          let msg = error.msg;
          this.showErrorMsg(msg);
        });
    } else {
      this.showErrorMsg('请输入盘点库存');
    }
  }

  private save() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    saveStockCheck(params)
      .then((res) => {
        this.showSuccessMsg('添加成功');
        this.collapseAllRows();
        this.getList();
      })
      .catch((error) => {
        let msg = error.msg;
        this.showErrorMsg(msg);
      });
  }

  private recordHandle() {
    this.$router.push({
      path: 'checkRecord'
    });
  }

  private large(val: any, index?: number) {
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
